import { PageHeader } from "@shared/components/PageHeader";
import { ArrowLeft } from "lucide-react";
import { useNavigate, useParams } from "react-router-dom";
import { useGetReadCycleDetails } from "../../hooks";
import { Tabs } from "@shared/ui/tabs";
import { ReadCycleProfileCard } from "./details";
import { KeyStatsCard } from "./keyStatsCard";
import { QuickActionsSidebar } from "./quickActionCard";
import { Card, CardHeader } from "@shared/ui/card";
import ReadCycleRunsTab from "./tabcomponents/readCycleRuns/readCycleRunsTab";
import { ReadCycleEntitiesTab } from "./tabcomponents/readCycleEntities/readCycleEntitiesTab";

const urlMapping = {
  readCycleEntities: "read-cycle-entities",
  readCycleRuns: "read-cycle-runs",
};

export const ReadCycleDetailsLanding = () => {
  const navigate = useNavigate();
  const { cycle_id } = useParams();
  const { data: readCycleDetails } = useGetReadCycleDetails(cycle_id);
  const tabComponents = {
    readCycleEntities: {
      label: "Read Cycle Entities",
      shortLabel: "Read Cycle Entities",
      component: <ReadCycleEntitiesTab data={readCycleDetails} />,
    },
    readCycleRuns: {
      label: "Read Cycle Runs",
      shortLabel: "Read Cycle Runs",
      component: <ReadCycleRunsTab />,
    },
  };
  return (
    <div>
      <div className="space-y-6">
        <div className="mb-4 flex items-center gap-4">
          {/* Back Arrow */}
          <ArrowLeft
            className="w-5 h-5 cursor-pointer text-gray-700"
            onClick={() => navigate("/mx/read-cycle/")}
          />

          {/* Page Header */}
          <div className="flex flex-col">
            <PageHeader
              title="View Read Cycle"
              subtitle="Track performance and progress of your meter reading cycles"
            />
          </div>
        </div>
        <div className="space-y-6">
          <div className="grid grid-cols-12 lg:grid-cols-12 gap-6">
            <div className="lg:col-span-8 space-y-6">
              <ReadCycleProfileCard data={readCycleDetails} />
            </div>
            <div className="lg:col-span-4 space-y-4">
              <KeyStatsCard data={readCycleDetails} />
              <QuickActionsSidebar data={readCycleDetails} />
            </div>
          </div>
        </div>
      </div>
      <Card className="mt-6">
        <CardHeader className="pb-3">
          <Tabs
            defaultValue="readCycleEntities"
            urlMapping={urlMapping}
            tabComponents={tabComponents}
            tabsListClassName="grid w-full grid-cols-2 mb-6"
            idPrefix="readCycle-tab"
            level={0}
          />
        </CardHeader>
      </Card>
    </div>
  );
};
